import { Component, OnInit } from '@angular/core';
import { VersionService } from '../modules/formbird-services';
import { Router } from '@angular/router';

@Component({
  selector: 'ft-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router,) {  }

  async ngOnInit() {
    if (!window.isSecureContext && window.location.hostname !== 'localhost') {
      this.router.navigate(['/notSecure'], { skipLocationChange: true });
    } else {
      await VersionService.checkServerVersion();
    }
    
  }

}
